import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "Do I need to be technical to use this?",
    a: "Not at all. We handle 100% of the build and setup. You give us access to your website and share information about your business. We take it from there. You just watch it go live.",
  },
  {
    q: "How long does setup actually take?",
    a: "7 days from the moment you sign and pay. We've built the process to be fast because we know you're losing leads every day you wait.",
  },
  {
    q: "What does the 1-year warranty actually cover?",
    a: "If your agent breaks, gives wrong information, or stops working correctly within the first year — we fix it. No extra charge. You're protected.",
  },
  {
    q: "What if I want to update what the agent says?",
    a: "Easy. Just reach out to us with updates — new pricing, new services, new hours, anything — and we'll retrain and redeploy your agent. Simple as that.",
  },
  {
    q: "What website platforms do you work with?",
    a: "Most major platforms — Squarespace, Wix, WordPress, Shopify, Webflow, custom HTML sites, and more. Book a call and we'll confirm compatibility in the first conversation.",
  },
  {
    q: "Is this just a basic chatbot?",
    a: "No. This is a trained AI sales agent powered by the same technology behind today's most advanced AI models. It understands context, handles nuanced questions, manages objections, and actively works to move your customer toward booking — not just answering yes/no questions.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#0A0F1E] fs-section">
      <div className="fs-container">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#C9A84C]" />
            <span className="fs-tag">Common Questions</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-[0.03em] leading-[0.95] text-white">
            Quick Answers.
          </h2>
        </div>

        <div className="mt-12 max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-white/12 rounded-lg px-5 bg-[#131929] hover:border-[#C9A84C]/40 transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-white font-medium text-base md:text-lg py-5 hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-sm md:text-[0.95rem] leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
